import axiosInstance from '../../axiosInstance';

const BASE = '/api/requests';

/**
 * @param {{ workflowVersionId?: number, liveProfileRefresh?: boolean }} [body]
 */
export async function createHcpRequestDraft(body = {}) {
  const payload = {};
  if (body.workflowVersionId != null && body.workflowVersionId !== '') {
    payload.workflow_version_id = Number(body.workflowVersionId);
  }
  if (body.liveProfileRefresh !== undefined) {
    payload.live_profile_refresh = Boolean(body.liveProfileRefresh);
  }
  const res = await axiosInstance.post(`${BASE}/create`, payload, {
    withCredentials: true,
  });
  return res.data;
}

export async function getHcpRequestDraft(draftId) {
  const res = await axiosInstance.get(`${BASE}/drafts/${draftId}`, {
    withCredentials: true,
    suppressErrorToast: true,
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
    params: { _cb: Date.now() },
  });
  return res.data;
}

/**
 * @param {number|string} draftId
 * @param {{ populated?: object, liveProfileRefresh?: boolean }} body
 */
export async function putHcpRequestDraft(draftId, body) {
  const payload = {};
  if (body.populated !== undefined) {
    payload.populated = body.populated;
  }
  if (body.liveProfileRefresh !== undefined) {
    payload.live_profile_refresh = Boolean(body.liveProfileRefresh);
  }
  const res = await axiosInstance.put(`${BASE}/drafts/${draftId}`, payload, {
    withCredentials: true,
    suppressErrorToast: true,
  });
  return res.data;
}

/**
 * Pre-submission readiness (ID image, license, education…) for draft snapshot.
 *
 * @param {number|string} draftId
 * @param {{ populated?: object, requestType?: string }} [body]
 */
export async function postValidateHcpDraftSubmission(draftId, body = {}) {
  const payload = {};
  if (body.populated !== undefined) {
    payload.populated = body.populated;
  }
  if (body.requestType != null && body.requestType !== '') {
    payload.request_type = String(body.requestType);
  }
  const res = await axiosInstance.post(
    `${BASE}/drafts/${draftId}/validate-submission`,
    payload,
    { withCredentials: true, suppressErrorToast: true }
  );
  return res.data;
}

/**
 * Final submit: validates on server (required fields + profile), sets draft status to submitted.
 *
 * @param {{
 *   draft_id?: number|string,
 *   draftId?: number|string,
 *   populated?: object,
 *   request_type?: string,
 *   requestType?: string,
 *   update_profile?: boolean,
 *   updateProfile?: boolean,
 * }} body
 */
export async function postSubmitHcpRequestDraft(body = {}) {
  const payload = {};
  const rid = body.draft_id ?? body.draftId;
  if (rid != null && rid !== '') {
    payload.draft_id = Number(rid);
  }
  if (body.populated !== undefined) {
    payload.populated = body.populated;
  }
  const rt = body.request_type ?? body.requestType;
  if (rt != null && rt !== '') {
    payload.request_type = String(rt);
  }
  if (body.update_profile !== undefined) {
    payload.update_profile = Boolean(body.update_profile);
  } else if (body.updateProfile !== undefined) {
    payload.update_profile = Boolean(body.updateProfile);
  }
  const res = await axiosInstance.post(`${BASE}/submit`, payload, {
    withCredentials: true,
    suppressErrorToast: true,
  });
  return res.data;
}
